import React from 'react'


export const BodyContainer = (comp) => {

    return <div className='body-container'>
        {comp.comp && comp.comp.map(El => El)}
    </div>
}
export const Highlights = ({contents}) => {
    return (<ul>
        {contents.map(el => <li>{el}</li>)}
    </ul>)

}

